module.exports = __webpack_public_path__ + "static/media/delhi.f182b1d5.png";